// The condition builder's pure logic: the described condition shape the server sends
// ({ part, attribute, label, predicate, predicate_label, value, ignored, reason }), how a new
// one is built from the picker, and how a list becomes the stored two-part query or the Reports
// index's request parameters. Vocabulary and reasons live in Ruby (ReportQuery, Channel::Prefilter);
// nothing here re-derives them.

export function conditionKey(condition) {
  return `${condition.part}:${condition.attribute}:${condition.predicate}`
}

// A condition added from the picker: never ignored, since the pickers offer nothing a
// pre-filter ignores. `value` is a string, or an array of the chosen option values for a list
// predicate; `value_label` names the chosen options.
export function fromPicker(attribute, predicate, value) {
  const pair = attribute.predicates.find(([p]) => p === predicate)
  const labels = new Map(attribute.options || [])
  const label = (v) => labels.get(v) ?? v
  const value_label = Array.isArray(value) ? value.map(label).join(", ") : label(value)
  return {
    part: attribute.part || "q", attribute: attribute.name, label: attribute.label,
    predicate, predicate_label: pair ? pair[1] : predicate, value, value_label, ignored: false, reason: null
  }
}

// The two-part query the server stores: { q: { "<attribute>_<predicate>": value }, results: { key: { predicate: value } } }.
export function toQuery(conditions) {
  const query = { q: {}, results: {} }
  for (const c of conditions) {
    if (c.part === "q") query.q[`${c.attribute}_${c.predicate}`] = c.value
    else query.results[c.attribute] = { ...(query.results[c.attribute] || {}), [c.predicate]: c.value }
  }
  return query
}

// [[name, value]] request parameters for the Reports index; a list value repeats name[].
export function toParams(conditions) {
  return conditions.flatMap((c) => {
    const name = c.part === "q" ? `q[${c.attribute}_${c.predicate}]` : `results[${c.attribute}][${c.predicate}]`
    return Array.isArray(c.value) ? c.value.map((v) => [`${name}[]`, v]) : [[name, c.value]]
  })
}
